"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles.css");
var _howToUse = require("../../../assets/connector/how-to-use.svg");
var _ButtonDisconn = _interopRequireDefault(require("../../ButtonDisconn"));
var _ModalState = _interopRequireDefault(require("../../../state-observables/modal/ModalState"));
var _HowToUseModal = _interopRequireDefault(require("../../modals/HowToUseModal"));
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MartyStatus = () => {
  const onDisconnect = () => {
    console.log("disconnecting");
    const connectedRaft = window.applicationManager.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.MARTY);
    if (connectedRaft) {
      window.applicationManager.disconnectGeneric(connectedRaft, () => {
        window.applicationManager.navigateTo("/activities");
      });
    } else {
      window.applicationManager.toaster.warn("No connected Marty found, getting you back to the home page.");
      window.applicationManager.navigateTo("/activities");
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "marty-status-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "disconnect-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonDisconn.default, {
        onClick: onDisconnect
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "how-to-use-container",
      onClick: () => _ModalState.default.setModal(_HowToUseModal.default, "How to use Sequencer!"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_howToUse.ReactComponent, {
        className: "marty-status-inner-box-how-to-use-svg"
      })
    })]
  });
};
var _default = exports.default = MartyStatus;